require('es6-promise').polyfill();
import 'nodelist-foreach-polyfill';
import {
  tns
} from "../node_modules/tiny-slider/src/tiny-slider";
import GLightbox from '../node_modules/glightbox/dist/js/glightbox';
import tabs from './modules/tabs';
import calc from './modules/calc'; 
import modal from './modules/modal';

window.addEventListener('DOMContentLoaded', () => {
  modal('[data-modal]', '.modal');
  calc();
  tabs('.types-head', '.types-tabcontent', '.types-header', 'active');

  const Header = tns({
    container: '.hero-slider',
    items: 1,
    slideBy: 1,
    autoplay: false,
    mouseDrag: true,
    controls: true,
    nav: true,
    navPosition: 'bottom',
    arrow: true
  });

  const sliderOne = document.querySelectorAll('.slider-1');
  sliderOne.forEach(item => {
    const slider = tns({
      container: item,
      items: 1,
      slideBy: 1,
      autoplay: false,
      mouseDrag: true,
      controls: true,
      nav: false,
      arrow: true,
      responsive: {
        1024: {
          items: 3,
        }
      }
    });
  });

  const sliderTwo = tns({
    container: '.slider-2',
    items: 1,
    slideBy: 1,
    autoplay: false,
    mouseDrag: true,
    controls: true,
    nav: false,
    arrow: true,
    responsive: {
      1024: {
        items: 4,
      }
    }
  });
  const sliderThree = tns({
    container: '.slider-3',
    items: 1,
    slideBy: 1,
    autoplay: false,
    mouseDrag: true,
    controls: true,
    nav: false,
    arrow: true,
    responsive: {
      1024: {
        items: 3
      }
    }
  });
  const sliderFour = tns({
    container: '.slider-4',
    items: 1,
    slideBy: 1,
    gutter: 0,
    autoplay: false,
    mouseDrag: true,
    controls: true,
    nav: true,
    navPosition: 'bottom',
    arrow: true,
    responsive: {
      1024: {
        items: 3,
        gutter: 30
      }
    }
  });

  const lightbox = GLightbox({
    'selector': '.glightbox'
  });
});